import React from 'react';
import PropTypes from 'prop-types';
import Media from '../../components/ui/Media';
import contactInfo from './contactInfo.js';
import SubTitle from '../../components/ui/SubTitle';

function ContactInfoList({ className }) {
  return (
    <div className={`${className || ''}`}>
      <SubTitle>Contact Info</SubTitle>
      <ul className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-1 gap-5 md:gap-8">
        {contactInfo.map((item, index) => (
          <li key={index}>
            <Media mediaInfo={item} className="h-full" />
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ContactInfoList;

ContactInfoList.propTypes = {
  className: PropTypes.string,
};
